<div class="widget-renderer" [class.widget-renderer--preview]="isPreview">
  <div class="widget-renderer__notice" *ngIf="isUnconfigured">
    <mat-icon>settings_input_component</mat-icon>
    <span>Configurar dispositivo</span>
  </div>

  <ng-container [ngSwitch]="renderType">
    <app-widget-number
      *ngSwitchCase="'NUMBER'"
      [widget]="renderWidget"
      [displayType]="'NUMBER'">
    </app-widget-number>

    <app-widget-number
      *ngSwitchCase="'GAUGE'"
      [widget]="renderWidget"
      [displayType]="'GAUGE'">
    </app-widget-number>

    <app-widget-line-chart
      *ngSwitchCase="'LINE'"
      [widget]="renderWidget"
      [isPreview]="isPreview">
    </app-widget-line-chart>

    <app-widget-line-chart
      *ngSwitchCase="'AREA'"
      [widget]="renderWidget"
      [isPreview]="isPreview">
    </app-widget-line-chart>

    <app-widget-bar-chart
      *ngSwitchCase="'BAR'"
      [widget]="renderWidget"
      [isPreview]="isPreview">
    </app-widget-bar-chart>

    <app-widget-device-list
      *ngSwitchCase="'DEVICE_LIST'"
      [widget]="renderWidget">
    </app-widget-device-list>

    <app-widget-map
      *ngSwitchCase="'MAP'"
      [widget]="widget"
      [isPreview]="isPreview">
    </app-widget-map>

    <div class="widget-renderer__unsupported" *ngSwitchDefault>
      <mat-icon>dashboard</mat-icon>
      <span>{{ renderType }}</span>
    </div>
  </ng-container>
</div>
